var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "slideout-shopping-basket flex flex-1" }, [
    _c(
      "div",
      { staticClass: "flex flex-col items-stretch justify-between flex-1" },
      [
        _c(
          "div",
          { staticClass: "md:py-80 md:px-40 px-20 pt-56 pb-24" },
          [
            _c("h2", { staticClass: "mb-16 text-gray-800" }, [
              _vm._v(_vm._s(_vm.translations.shopping_basket_title))
            ]),
            _vm._v(" "),
            _vm.message != null && _vm.message != ""
              ? _c(
                  "div",
                  {
                    staticClass:
                      "bg-blue rounded-xs text-14 lg:mb-16 flex items-center w-full px-16 py-16 mb-24 font-medium leading-snug text-white transition-opacity"
                  },
                  [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(_vm.svg("plus-circle", "mr-16"))
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { domProps: { innerHTML: _vm._s(_vm.message) } })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(this.basket.products, function(product) {
              return _c("div", { key: product.id, staticClass: "flex mb-16" }, [
                _c("img", {
                  staticClass:
                    "w-80 h-80 rounded-xs object-cover object-center mr-16",
                  attrs: {
                    src: _vm.getFirstImage(product.productData),
                    alt: product.productData.name
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex-col py-8" }, [
                  _c(
                    "p",
                    { staticClass: "text-16 mb-8 font-bold text-gray-800" },
                    [
                      _c("span", [_vm._v(_vm._s(product.amount) + "x")]),
                      _vm._v(" "),
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(product.productData.name)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex flex-wrap items-center" }, [
                    _c(
                      "span",
                      {
                        staticClass:
                          "text-14 font-medium leading-tight text-gray-500"
                      },
                      [
                        _vm._v(
                          "€ " +
                            _vm._s(
                              _vm.formatCurrency(
                                _vm.getVariantPrice(
                                  product,
                                  _vm.$store.getters["pricesIncludingVat"]
                                )
                              )
                            )
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "text-10 mx-8 font-medium text-gray-500" },
                      [_vm._v("•")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass:
                          "text-14 hover:border-transparent font-medium leading-tight text-gray-500 transition-colors border-b border-gray-500",
                        attrs: { href: "/product/" + product.productData.slug }
                      },
                      [_vm._v(_vm._s(_vm.translations.view_product))]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex flex-wrap items-center mt-8" },
                    [
                      _vm._l(
                        product.productData.options.filter(function(o) {
                          return o.type !== "opp_calc"
                        }),
                        function(option) {
                          return [
                            _c(
                              "span",
                              {
                                key: option.key,
                                staticClass:
                                  "text-14 font-medium leading-tight text-gray-500"
                              },
                              [
                                _vm._v(
                                  _vm._s(product.variant.content[option.key])
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                key: option.key + "_bull",
                                staticClass:
                                  "text-10 last:hidden mx-8 font-medium text-gray-500"
                              },
                              [_vm._v("•")]
                            )
                          ]
                        }
                      )
                    ],
                    2
                  )
                ])
              ])
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "md:px-40 px-20 py-32 border-t border-gray-300" },
          [
            _c("div", { staticClass: "flex justify-between mb-8" }, [
              _c("span", { staticClass: "text-black" }, [
                _vm._v(_vm._s(_vm.translations.subtotal))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "text-gray-500" }, [
                _vm._v("€ " + _vm._s(_vm.subTotal))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex justify-between mb-8" }, [
              _c("span", { staticClass: "text-black" }, [
                _vm._v(_vm._s(_vm.translations.vat))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "text-gray-500" }, [
                _vm._v("€ " + _vm._s(_vm.vat))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex justify-between mb-24" }, [
              _c("span", { staticClass: "text-black" }, [
                _vm._v(_vm._s(_vm.translations.shipping))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "text-gray-500" }, [
                _vm._v("Volgende stap")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex justify-between mb-24" }, [
              _c("span", { staticClass: "text-20 font-bold text-black" }, [
                _vm._v(_vm._s(_vm.translations.total))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "text-gray-500" }, [
                _vm._v("€ " + _vm._s(_vm.totalPrice))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-center" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn-green btn-rounded w-full mb-24",
                  attrs: { href: "/winkelmandje" }
                },
                [_vm._v(_vm._s(_vm.translations.submit_button_slideout))]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass:
                    "hover:border-transparent font-bold leading-tight text-black transition-colors border-b border-black",
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.close($event)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.translations.continue_shopping_link))]
              )
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }